import { Box, Typography, Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from '../ui/elements/buttons/Button';
import PaymentCard from '../modules/payment/components/PaymentCard';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import AddCard from '../modules/payment/components/AddCard';
import { usePayments } from '../modules/payment/queries/useCards';
import { Card } from '../modules/payment/paymentsType/Card';
import CircularLoader from '../ui/elements/loader/CircularLoader';
import useCreateCard from '../modules/payment/mutations/useCreateCard';
import useDeleteCard from '../modules/payment/mutations/useDeleteCard';
import ConfirmDialog from '../utils/ConfirmDialog';
import { useUserContext } from '../modules/user/UserContext';
import { useCreateStripeId } from '../modules/payment/mutations/useCreateStripeCustomerId';
import { User } from '../modules/user/userType/User';

const Payments: React.FC = () => {
    const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [selectedCard, setSelectedCard] = useState<Card | null>(null);
    const { user, setUser,refreshUser } = useUserContext();
    const customerId = user?.stripeCustomerId;

    const { mutate: createStripeId } = useCreateStripeId();
    const { data: cardsData, isLoading, refetch: refetchCards } = usePayments({ customerId: customerId ?? '' });
    const cards: Card[] = cardsData?.data?.paymentMethods || [];

    const { mutate: addCardMutation, isPending: isAddingCard } = useCreateCard();
    const { mutate: deleteCard } = useDeleteCard();

    const [isCreatingStripeId, setIsCreatingStripeId] = useState(false);

    // Trigger Stripe ID creation only if customerId is missing
   useEffect(() => {
    let called = false;

    const createStripe = async () => {
        if (!user?.stripeCustomerId && !called) {
            called = true;
            try {
                const response = await createStripeId();
                refreshUser();
                // console.log("oooooooooooooo", response);
            } catch (error) {
                console.error("Error creating Stripe ID:", error);
            }
        }
    };

    createStripe();
}, [user?.stripeCustomerId, createStripeId]); // ✅ Depend only on stripeCustomerId


   
    const handleRemoveClick = (card: Card) => {
        setSelectedCard(card);
        setOpenRemoveDialog(true);
    };

    const handleCloseRemoveDialog = () => {
        setOpenRemoveDialog(false);
        setSelectedCard(null);
    };

    const handleConfirmRemove = () => {
        const paymentMethodId = selectedCard?.id;
        if (!paymentMethodId) return;

        deleteCard(paymentMethodId, {
            onSuccess: () => {
                refetchCards();
            },
            onError: (error) => {
                console.error("Error removing card:", error);
            },
        });

        handleCloseRemoveDialog();
    };

    const handleAddCard = (paymentMethodId: string) => {
        if (!customerId) {
            console.error('Customer ID is missing.');
            return;
        }
        // console.log("customerrrAddVcard", customerId, paymentMethodId)

        addCardMutation({ paymentMethodId, customerId }, {
            onSuccess: () => {
                refetchCards();
                setOpenAddDialog(false);
            },
        });
    };

    const handleOpenAddDialog = () =>{
        setOpenRemoveDialog(false);
    }

    return (
        <Box p={2} mt={2}>
            {/* add card dialog */}
            <Dialog open={openAddDialog} onClose={handleOpenAddDialog}>
            <AddCard handleAddCard={handleAddCard}  setOpenAddDialog={setOpenAddDialog} />
            </Dialog>

            <Typography variant="h4">My Cards</Typography>
            {isLoading || isCreatingStripeId ? (
                <CircularLoader />
            ) : 
                <Box bgcolor="white" borderRadius="20px" p={4}>
                    <Box display="flex" mb={2} gap={2}>
                    <Button background={'#FFE2E2'} color={'#FF4646'}>
                    Saved cards
                    </Button>
                        <Button
                            onClick={() => {setOpenAddDialog(true);refreshUser();}}
                            background={"white"}
                            color={"black"}
                            border="1px solid black"
                            startIconn={<AddRoundedIcon />}
                        >
                            Add card
                        </Button>
                    </Box>
                    <Box mt={4} display="flex" flexWrap="wrap">
                    {cards.length ?
                    <>
                        {cards.map((card, index) => (
                                <Box key={index} mr={4} mb={4}>
                                    <PaymentCard card={card} onRemove={handleRemoveClick} />
                                </Box>
                        ))}
                        </>
                        :
                            <Typography>No card added</Typography>
                    }
                </Box>

            </Box>
            }

            {/* remove card dialog */}
            <ConfirmDialog
                open={openRemoveDialog}
                onClose={handleCloseRemoveDialog}
                onConfirm={handleConfirmRemove}
                message={`Are you sure you want to remove the card ending with ${selectedCard?.last4}?`}
                confirmText="Remove"
                cancelText="Cancel"
            />
        </Box>
    );
};

export default Payments;
